import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  constructor() { }

getItem(key: string) {
    try {
        const raw = sessionStorage.getItem(key);
        if (raw === null) return null;
        return JSON.parse(raw);
    } catch (error) {
        console.log(error);
        return null;
    }
}

setItem(key: string, value: string | any) {
    try {
        return sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
        console.log(error);
    }
}

  removeItem(key: string) {
    try {
      return sessionStorage.removeItem(key);
    } catch (error) {
      console.log(error);

    }
  }

  clearEntireSession() {
    sessionStorage.clear();
  }

  getAllKeys(): string[] {
    return Object.keys(sessionStorage);
}

}